import { useMemo } from 'react';

import { convertGroupKeyToIndex } from '../helpers/groupedItems';
import type { GenericItem } from '../types';
import { ItemsProp, InputItemGroup } from '../types';

export default <TItem extends GenericItem>({
  items,
  maybeGroupedItems,
  selectedGroupKey,
}: {
  items: TItem[];
  maybeGroupedItems: ItemsProp<TItem>;
  selectedGroupKey?: string;
}): {
  filteredGroupItems: TItem[];
  showGroupHeaders: boolean;
} => {
  const filteredGroupItems = useMemo(() => {
    const groupIndex = convertGroupKeyToIndex(selectedGroupKey || '');

    if (groupIndex === null || groupIndex === undefined || groupIndex < 0) {
      return items;
    }
    const group = maybeGroupedItems[groupIndex] as InputItemGroup<TItem>;
    return items.filter((item) => group.items?.includes(item));
  }, [maybeGroupedItems, selectedGroupKey, items]);

  return {
    filteredGroupItems,
    showGroupHeaders: !selectedGroupKey,
  };
};
